export const styles = {
  mainContainer: "relative w-full h-screen bg-no-repeat bg-cover bg-landing",

  //logo
  logoContainer: "absolute flex items-end space-x-2 top-5 left-10",
  logoImg: "w-8 h-8 animate-pulse",
  logoCaption: "text-lg text-blue-200 uppercase",

  //left container
  leftContainer:
    "flex flex-col items-center justify-center h-screen px-8 lg:w-1/2 lg:px-0",

  //reset password form
  formContainer:
    "w-full px-6 py-6 shadow-xl md:py-16 sm:w-1/2 md:px-8 xl:px-12 lg:w-2/3 rounded-xl h-fit bg-black/40 shadow-black/50",
  titleContainer: "mb-10 lg:mb-12 sm:space-y-4",
  title: "text-4xl font-bold text-yellow-200 md:text-5xl xl:text-5xl",
  subtitle: "p-1 mb-10 text-lg text-blue-100 sm:text-xl xl:text-2xl",
  resetLink: "text-2xl font-semibold text-blue-300",
  emailInput:
    "my-1 bg-transparent border-white rounded-full placeholder:text-white focus:border-yellow-200 focus:ring-yellow-200",
  sendBtn:
    "py-2 mt-6 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 sm:py-2.5 text-white",
};
